module.exports = __webpack_public_path__ + "img/job_itinerary_1.803eaeff.png";